const navigationServiceReload = async (serviceCode, basePath = '/booking') => {
  if (serviceCode === 'INS') return;
  try {
    const currentUrl = new URL(window.location.href);
    const lowerCaseServiceCode = serviceCode.toLowerCase();
    const serviceCodeAlreadyInUrl = currentUrl.pathname.toLowerCase().includes(`/${lowerCaseServiceCode}`);

    if (!serviceCodeAlreadyInUrl) {
      const bookingRegex = new RegExp(`(${basePath})(-[^/]*)?`);
      const newUrlPathname = currentUrl.pathname.replace(bookingRegex, `$1/${lowerCaseServiceCode}`);
      const newUrl = new URL(currentUrl.href);
      newUrl.pathname = newUrlPathname;

      // Navigate to new URL and reload the page
      window.location.href = newUrl.href;
    }
  } catch (error) {
    console.error('Error during navigationServiceReload:', error);
  }
};
export default navigationServiceReload;
